// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"08ddf7c5","264":"cf60903e","477":"cd2ee8b8","584":"9498dc64","658":"b6d9e519","775":"a913224e","805":"f167dba8","937":"05c01e71","947":"5b6cea1c"}[chunkId] + ".chunk.css";
};